import { isTaskInProgress } from '@/pages/ipe/workbench/utils/taskProgress';

/** 服务端 Worker 是否仍在处理该图案裁剪任务 */
export function isImageCropServerWorkerActive(task) {
  if (!task?.result?.serverWorker) return false;
  const phase = String(task?.result?.batchPhase || '').toLowerCase();
  if (phase === 'cancelled' || phase === 'completed') return false;
  const status = String(task?.status || '').toLowerCase();
  if (['partial', 'canceled', 'cancelled', 'success', 'failed'].includes(status)) return false;
  if (isTaskInProgress(status)) return true;
  return ['queued', 'running', 'submitting', 'polling'].includes(phase);
}
